import React from "react";
import { formatDate } from "../../utils";

const NotificationListItem = ({ item }) => {
  return (
    <div className="notification-list-item">
      <div className="notification-list-item-logo">
        <img src="/images/lg-znak.png" className="img-fluid" alt="LG" />
      </div>
      <div className="notification-list-item-header">
        <div className="notification-list-item-header-title">{item?.title}</div>
        <div
          className="notification-list-item-header-body"
          dangerouslySetInnerHTML={{ __html: item?.body }}
        />
        <div className="notification-list-item-header-date">
          {formatDate(item?.createdAt)}
        </div>
      </div>
    </div>
  );
};

export default NotificationListItem;
